const $forms = $('.userform, .form--styled');

const setupRequiredPlaceholders = () => {
    $forms.find('input:required').each((index, el) => {
        if (el.type === 'radio') {
            const $holder = $(el).closest('.field.optionset');

            if (!$holder.data('placeholder-set')) {
                const $label = $holder.find('.left');

                $label.text(`${$label.text()} *`);
                $holder.data('placeholder-set', true);
            }
        }
    });
};

const setupFlyLabels = () => {
    $forms.flyLabels();
};

const setupFormValidation = () => {
    const parsleyConfig = {
        trigger: 'blur',
        errorsContainer: (parsleyField) => {
            const fieldSet = parsleyField.$element.closest('.middleColumn');

            if (fieldSet.length > 0) {
                return fieldSet;
            }

            return parsleyField;
        },
    };

    if (!$forms.length) {
        return;
    }

    $forms.parsley(parsleyConfig);
};

const setupDropdowns = () => {
    $forms.each((index, el) => {
        $(el).find('select option[value=""]').prop('disabled', true);
    });
};

const setupFormSubmit = () => {
    $forms.each((index, el) => {
        const valid = $(el).parsley().isValid();

        if (!valid) {
            // $(el).find('button[type=submit]').prop('disabled', true);
            $(el).find('input[type=submit]').prop('disabled', true);
        }

        $(el)
            .find(':input')
            .on('change keyup', () => {
                if ($(el).parsley().isValid()) {
                    $(el).find('input[type=submit]').prop('disabled', false);
                } else {
                    $(el).find('input[type=submit]').prop('disabled', true);
                }
            });

        $(el).on('submit', () => {
            if ($(el).parsley().isValid()) {
                $(el)
                    .find('input[type=submit]')
                    .prop('disabled', true)
                    .addClass('submitting');
            }
        });
    });
};

const setupFileInputs = () => {
    $forms.each((index, el) => {
        $(el)
            .find('input[type=file]')
            .each((index, el) => {
                const $label = $(el).closest('.field.file').find('label.left');
                const originalLabel = $label.text();

                $(el).on('change', (e) => {
                    const filename = e.target.value.split('\\').pop();

                    if (filename) {
                        $label.text(filename);
                    } else {
                        $label.text(originalLabel);
                    }
                });
            });
    });
};

const setupFormMasks = () => {
    $(':input.phone').mask('(000) 000-0000');
};

export default {
    can: () => $forms.length,
    run: () => {
        setupRequiredPlaceholders();
        setupFlyLabels();
        setupFormValidation();
        setupDropdowns();
        setupFormSubmit();
        setupFileInputs();
        setupFormMasks();
    },
};
